import React, { forwardRef } from 'react'
import MaskedInput from 'react-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import { Input, InputProps } from '../Input'

export type CurrencyInputProps = Omit<
  InputProps,
  'type' | 'textPrefix' | 'sideButton' | 'onConfirm'
> & {
  allowDecimal?: boolean
}

export const CurrencyInput = forwardRef<
  () => HTMLInputElement,
  CurrencyInputProps
>(({ allowDecimal, ...rest }, ref) => {
  return (
    <MaskedInput
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={ref as any} // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/28884
      mask={createNumberMask({
        prefix: '',
        thousandsSeparatorSymbol: '.',
        decimalSymbol: ',',
        allowDecimal,
        integerLimit: 10,
      })}
      render={(ref, innerProps) => {
        return <Input {...innerProps} ref={ref} type='text' textPrefix={'€'} />
      }}
      {...rest}
    />
  )
})

CurrencyInput.displayName = 'CurrencyInput' // Typescript workaround for ForwardRef Component
